import React, { useContext, useEffect } from 'react';
import { WardrobeHeightContext } from '../contexts/WardrobeHeightContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import SelectionButtons from '../components/buttons/SelectionButtons';
import TopInstructionAndLink from '../components/TopInstructionAndLink';
import LinkButton from '../components/buttons/LinkButton';
import Illustration from '../components/common/Illustration';
import FixedContainer from '../components/common/FixedContainer';
import ProgressBar from '../components/ProgressBar/index';
import ReactGA from 'react-ga';
import { reactLocalStorage } from 'reactjs-localstorage';

const HeightSettings = props => {
  ReactGA.event(
    {
      category: 'Height',
      action: 'Select height of wardrobe',
      transport: 'beacon',
    },
    ['tracker1', 'tracker2'],
  );
  const { wardrobeHeight, setWardrobeHeight } = useContext(WardrobeHeightContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { setActiveWardrobe } = useContext(ActiveWardrobeContext);
  const { dimensions } = props;

  useEffect(() => {
    if (typeof wardrobeHeight !== 'number' && !!dimensions) {
      setWardrobeHeight(dimensions.height[0]);
      setActiveWardrobe(0);
    }
    /* eslint-disable-next-line */
  }, [wardrobeHeight, dimensions]);

  useEffect(() => {
    reactLocalStorage.setObject('wardrobeHeight', wardrobeHeight);
    setActiveWardrobe(0);
    /* eslint-disable-next-line */
  }, []);

  return (
    <div className="container height-settings">
      <ProgressBar />
      <TopInstructionAndLink text="Przed rozpoczęciem konfiguracji, wybierz wysokość szafy." />
      <div className="container">
        {!!dimensions && !!wardrobeHeight && (
          <SelectionButtons
            title=""
            selectionGroupName="width"
            params={dimensions.height}
            unit="cm"
            setValue={setWardrobeHeight}
            activeValue={wardrobeHeight}
            setWardrobesConfigs={setWardrobesConfigs}
            wardrobesConfigs={wardrobesConfigs}
          />
        )}
      </div>
      {wardrobeHeight > 218 ? (
        <Illustration
          imgUrl={`${process.env.PUBLIC_URL}/img/svg-illustrations/height_wardrobe.svg`}
        />
      ) : (
        <Illustration imgUrl={`${process.env.PUBLIC_URL}/img/svg-illustrations/height.svg`} />
      )}
      <FixedContainer padding={true}>
        <LinkButton text="Przejdź Dalej" link="/wardrobe-type" icon />
      </FixedContainer>
    </div>
  );
};

export default HeightSettings;
